import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => {
	return {
		drawerContent: {
			borderRadius : "1rem 1rem 0 0",
			height       : "fit-content !important"
		},
		header: {
			padding        : "1.4rem",
			display        : "flex",
			flexDirection  : "row",
			alignItems     : "center",
			justifyContent : "space-between",
			borderBottom   : `1px solid ${ theme.other.colors.border.secondary }`
			// background     : theme.other.paletteNew.darkModeInclinedBlack1
		},
		body: {
			background    : theme.other.colors.background.primary,
			display       : "flex",
			flexDirection : "column",
			padding       : "1.6rem",
			gap           : "1rem"
		},
		link: {
			textDecoration: "underline"
		},
		note: {
			fontStyle: "italic"
		},
		question: {
			"& > div:first-child": {
				marginBottom: "0.4rem"
			}
		}
	};
} );
